export const RATINGS_LIST = 'ratings-list'
export const FILTER_RATINGS_LIST = 'filter-ratings-list'
export const OPERATOR_DASHBOARD_RATINGS = 'operator-dashboard-ratings'
export const SORT_DATA_BY = 'sort-data-by'
export const ROUTE_RATINGS_DETAILS = 'route-ratings-details'
export const CHANGE_VIEW = 'change-view'
export const V2_SOURCE_CITIES = 'v2-source-cities'
export const V2_DEST_CITIES = 'v2-dest-cities'
export const UNREVIEWED_LIST = 'unreviewed-list'
export const SHOW_ASK_FOR_REVIEWS = 'showAskForReviews'

